import React from 'react';
import X2JS from 'x2js';
import _ from 'underscore';
import { urls } from './urls';
import { fetch } from './fetch';
import { Image } from 'react-bootstrap';

export const isWinTop = window === window.top;
export const projectFlag = isWinTop ? '' : 'UDESK-IM-COLLEAGUE';
export const userSearchMatchs = ["nick_name", "pinyin_name", "email", "description"];
export const groupSearchMatchs = ["name", "pinyin_name"];

let x2js = new X2JS();

_.templateSettings = {
    interpolate: /\{\{(.+?)\}\}/g
};

export function guid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export function mixinsClassName() {
    let classNames = [];
    _.each(arguments, function(item) {
        if (item) {
            if (_.isString(item)) {
                classNames.push(item);
            } else {
                _.each(item, (val, key) => {
                    if (key === "className") {
                        val && classNames.push(val);
                    } else if (_.isBoolean(val) && val) {
                        classNames.push(key);
                    }
                });
            }
        }
    });
    return classNames.join(" ");
}

export function createElement(props) {
    props = _.extend({}, props, this.props, {
        className: mixinsClassName(this.props, props)
    });
    let beforeElement = props.beforeElement;
    let afterElement = props.afterElement;
    let children = props.children;

    delete props.beforeElement;
    delete props.afterElement;
    delete props.children;

    // {
    //     React.Children.map(children, function (child) {
    //       if(child){
    //         return React.createElement(child.type, child.props);
    //       }
    //     })
    // }
    return (
        <div {...props}>
          {beforeElement}
          {children}
          {afterElement}
        </div>
    );
}

export function createAvatarElement(props) {
    let isImg = !!props.src;
    let text = props.text || '';
    let bytes;
    let style = _.pick(props, "width", "height");

    props = _.clone(props);
    props.className = mixinsClassName("img-circle", props, !isImg ? "avatar-text" : "");

    if (props.src) {
        delete props.text;
        return <Image {...props}/>;
    }

    text = ((text[0] || '') + (props.width < 30 ? '' : (text[1] || ''))).toUpperCase();
    bytes = getCharBytes(text);
    style.height && (style.lineHeight = (style.height - (bytes > 2 ? 0 : 2)) + "px");
    (bytes > 2) && (style.fontSize = '12px');
    props = _.omit(props, "width", "height");

    return <div {...props} style={style}>{text}</div>;
}

export function activeItems(items, activeItem, key = 'id', activeKey = 'active') {
    _.each(items, (item) => {
        item[activeKey] = activeItem === item || activeItem[key] === item[key]
    })
}

export function contiansKeyword(keyword, obj, ...keys) {
    keyword = keyword || '';
    obj = _.pick(obj, ...keys);

    for (var key in obj) {
        if ((obj[key] || "").toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
            return true;
        }
    }
    return false;
}

export function getCharBytes(str) {
    if (str) {
        let len = 0;
        for (let i = 0, l = str.length, code; i < l; i++) {
            code = str.charCodeAt(i);
            len += (code >= 0 && code <= 128) ? 1 : 2;
        }
        return len;
    }
    return 0;
}

export function substrByBytes(str, charLen, ellipsis = '...') {
    if (!str) return '';

    var realLength = 0,
        len = str.length,
        code;

    if (len * 2 <= charLen) {     
        return str;
    }

    for (var i = 0; i < len; i++) {
        code = str.charCodeAt(i);
        realLength += (code >= 0 && code <= 128) ? 1 : 2;
        if (realLength >= charLen) {
            return str.substring(0, i + 1) + (i + 1 === len && realLength === charLen ? '' : ellipsis);
        }
    }
    return str;
}

export function urlParams(url = window.location.search) {
    var obj = {},
        arr = url.match(new RegExp('[\?\&][^\?\&]+=[^\?\&]+', 'g'));
    if (arr) {
        for (var i = 0, l = arr.length; i < l; i++) {
            try {
                var _obj = arr[i].substring(1).split('='),
                    key = decodeURIComponent(_obj[0]),
                    val = decodeURIComponent(_obj[1]);
                obj[key] = val;
            } catch (e) {}
        }
    }
    return obj;
}

export function urlParse(obj) {
    let arr = [];
    _.each(obj, (val, key) => {
        key = encodeURIComponent(key);
        val = encodeURIComponent(val);
        val && arr.push(`${key}=${val}`);
    });
    return arr.join("&");
}

export function genNickName(data, key = 'nick_name', separator = '、') {
    return _.map(data, (item) => {
        return item[key] || "";
    }).join(separator);
}

export function postMessage(type, data = {}, origin = "*") {
    if (type) {
        data.type = type;
        try {
            window.parent && window.parent.postMessage(JSON.stringify(data), origin);
        } catch (ex) {}
    }
}

export function onPostMessage(handler) {
    window.addEventListener('message', (ev) => {
        let data = {};
        try {
            data = JSON.parse(ev.data);
        } catch (ex) {}

        handler(data.type, data);
    });
}

export function getAttr(obj, path) {
    if (!path || !obj) return;

    _.each(path.split("."), (key) => {
        obj && (obj = obj[key]);
        if (typeof obj === undefined) {
            return false;
        }
    });
    return obj;
}

export function xmlToJSON(xml) {
    return x2js.xml_str2json(xml) || {};
}

export function replaceTpl(str, data) {
    let compiled = _.template(str);
    return compiled(data);
}

export function pickPrefix(obj, prefix) {
    let result = {};

    for (var k in obj) {
        if (k.indexOf(prefix) === 0) {
            result[k] = obj[k];
        }
    }

    return result;
}

export function omitPrefix(obj, prefix) {
    let result = {};

    for (var k in obj) {
        if (k.indexOf(prefix) !== 0) {
            result[k] = obj[k];
        }
    }

    return result;
}

export function mapFileType(ext) {
    if (/^doc|docx|odt|wps$/i.test(ext)) {
        return 'word';
    }

    if (/^xls|xlsx$/i.test(ext)) {
        return 'excel';
    }

    if (/^ppt|pptx$/i.test(ext)) {
        return 'ppt';
    }

    return ext;
}

export function isImg(type) {
    return /^image/.test(type)
}

function getExt(urlData) {
    var arr = urlData.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    return mime.replace("image/", "");
}

function _addToken(fileObj, cfg) {
    var config = cfg.config || {};
    var formObj = new FormData();

    formObj.append('name', fileObj.name);
    formObj.append('type', fileObj.type);
    formObj.append('lastModifiedDate', fileObj.lastModifiedDate);
    formObj.append('size', fileObj.size);
    formObj.append('policy', config.policy);
    formObj.append('OSSAccessKeyId', config.accessid);
    formObj.append('Signature', config.signature);
    formObj.append('key', cfg.key);
    formObj.append('file', fileObj);
    return formObj;
}

export function base64toFile(dataurl, filename) {
    var arr = dataurl.split(',');
    var mime = (arr[0] || '').match(/:(.*?);/)[1];
    var bytes = window.atob(arr[1]);

    var ab = new ArrayBuffer(bytes.length);
        
    var u8arr = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
        u8arr[i] = bytes.charCodeAt(i);
    }

    // 处理异常,将ascii码小于0的转换为大于0
    // var n = new ArrayBuffer(bytes.length);
    // var n = bytes.length;
    // var u8arr = new Uint8Array(n);
    // while (n--) {
    //     u8arr[n] = bytes.charCodeAt(n);
    // }
    // return new Blob([u8arr], { type: mime });
    // 转换成file对象
    return new File([u8arr], filename, { type: mime });
}

export async function sendAliBase64(cfg) {
    var config = cfg.config || {};
    var ext = getExt(cfg._data);
    var imageName = 'image' + (+new Date()) + ('' + Math.random() * 1000000).substring(0, 3) + '.' + ext;
    cfg.random_filename = imageName;
    cfg.key = config.dir + imageName;
    cfg.url = `${config.host}/${cfg.key}`;

    var fileObj = base64toFile(cfg._data, imageName);
    var formDateObj = _addToken(fileObj, cfg);

    let res = await fetch(config.host, {
            method: 'POST',
            body: formDateObj,
            cache: 'no-cache',
            type: 'formData',
            credentials: 'include',
            mode: 'cors'
        });
    if (res.ok) {
        cfg.success && cfg.success({ src: cfg.url, file: fileObj, cfg: cfg});
    }

    // return $.ajax({
    //     url: config.host,
    //     type: 'POST',
    //     data: formDateObj,
    //     cache: false,
    //     contentType: false,
    //     processData: false,
    //     success: function (res) {
    //         cfg.success && cfg.success({ src: cfg.url });
    //     },
    //     error: function (err) {
    //         common.tips.error();
    //         !cfg.noTip && common.tips.error("上传失败，请重新上传");
    //     },
    // }, 'json');
}



// WEBPACK FOOTER //
// ./src/utils/base.js